export enum IntentStatus {
    Active = 'active',
    Inactive = 'inactive',
    Done = 'done',
}
